import { RJSFSchema } from "@rjsf/utils/lib/types";

export const clientanamnese_clean_on_submit = (dataStore: Record<string, any>) => {
  if ("p_breathing" in dataStore) {
    // EXTEND osas_sleep fields
    if ("fs_osas_sleep" in dataStore["p_breathing"]) {
      if ("osas" in dataStore["p_breathing"]["fs_osas_sleep"]) {
        if (dataStore["p_breathing"]["fs_osas_sleep"]["osas"] === "osas_no") {
          dataStore["p_breathing"]["state_osas_diagnosis"] = 0;
          dataStore["p_breathing"]["fs_osas_sleep"]["osas_source"] = [];
        }
        if (dataStore["p_breathing"]["state_osas_diagnosis"] === 0) {
          dataStore["p_breathing"]["fs_osas_diagnosis"] = undefined;
        }
        if (dataStore["p_breathing"]["state_osas_diagnosis"] === 1) {
          dataStore["p_breathing"]["fs_ent_visit"] = undefined;
        }
      }
    }
  }

  if ("p_therapies" in dataStore) {
    if (dataStore["p_therapies"]["state_applied_cpap_therapy"] === 0) {
      dataStore["p_therapies"]["fs_cpap_using_1"] = undefined;
    }
    if ("fs_therapies" in dataStore["p_therapies"]) {
      if ("recommended_therapies" in dataStore["p_therapies"]["fs_therapies"]) {
        const selected: string[] = dataStore["p_therapies"]["fs_therapies"]["recommended_therapies"];
        if (!selected.includes("Operation")) {
          dataStore["p_therapies"]["fs_therapies"]["operation_where"] = undefined;
          dataStore["p_therapies"]["fs_therapies"]["operation"] = undefined;
        }
        if (!selected.includes("other")) {
          dataStore["p_therapies"]["fs_therapies"]["other_recom_therapies"] = undefined;
        }
        if (dataStore["p_therapies"]["fs_therapies"]["operation"] !== "yes") {
          dataStore["p_therapies"]["fs_therapies"]["operation_where"] = undefined;
        }
      }
      if ("applied_therapies" in dataStore["p_therapies"]["fs_therapies"]) {
        const selected: string[] = dataStore["p_therapies"]["fs_therapies"]["applied_therapies"];
        if (!selected.includes("other")) {
          dataStore["p_therapies"]["fs_therapies"]["other_therapies"] = undefined;
        }
      }
    }
  }

  if ("p_suffer" in dataStore) {
    if ("fs_epilepsy" in dataStore["p_suffer"]) {
      if (dataStore["p_suffer"]["fs_epilepsy"]["epilepsy"] !== "yes") {
        dataStore["p_suffer"]["fs_epilepsy"]["epilepsy_last_occurance"] = undefined;
      }
    }
  }
};

export const clientanamnese_on_change_rule = (dataStore: Record<string, any>, _localParamData?: any) => {
  if ("p_breathing" in dataStore) {
    // EXTEND osas_sleep fields
    dataStore["p_breathing"]["state_osas_diagnosis"] = 0;
    if ("fs_osas_sleep" in dataStore["p_breathing"]) {
      if ("osas_source" in dataStore["p_breathing"]["fs_osas_sleep"]) {
        const selected: string[] = dataStore["p_breathing"]["fs_osas_sleep"]["osas_source"];
        if (selected.includes("osas_diagnosis")) {
          dataStore["p_breathing"]["state_osas_diagnosis"] = 1;
        }
      }
    }
  }

  if ("p_therapies" in dataStore) {
    // EXTEND CPAP fields
    dataStore["p_therapies"]["state_applied_cpap_therapy"] = 0;
    if ("fs_therapies" in dataStore["p_therapies"]) {
      if ("recommended_therapies" in dataStore["p_therapies"]["fs_therapies"]) {
        const selected: string[] = dataStore["p_therapies"]["fs_therapies"]["applied_therapies"];
        if (selected.includes("CPAP")) {
          dataStore["p_therapies"]["state_applied_cpap_therapy"] = 1;
        }
      }
    }
  }

  // EXTEND checkboxe list (ALERT TV_NP)
  if ("p_contact" in dataStore) {
    dataStore["p_contact"]["state_referred_by_doctor"] = 0;
    if ("fs_alert_velumount" in dataStore["p_contact"]) {
      if ("alert_velumount" in dataStore["p_contact"]["fs_alert_velumount"]) {
        const selected: string[] = dataStore["p_contact"]["fs_alert_velumount"]["alert_velumount"];
        // if (!selected.includes("alert_velumount_intent_tv_np")) {
        //   const filtered = selected.filter((v) => v.startsWith("alert_velumount_intent_tv_np"));
        //   if (filtered.length) {
        //     dataStore["p_contact"]["fs_alert_velumount"]["alert_velumount"] = [...selected, "alert_velumount_intent_tv_np"];
        //   }
        // }

        // Extend Referrred DOCTOR Field
        dataStore["p_contact"]["state_referred_by_doctor"] = selected.includes("alert_velumount_by_doctor") ? 1 : 0;
      }
    }
  }

  // clientanamnese_clean_on_submit(dataStore);
};

export const clientanamnese_steps = (t: (lang: string, params?: Record<string, string>) => string) => [
  // { title: t("survey.anamnese.p_start.nav") },
  // { title: t("survey.anamnese.p_contact.nav") },
  // { title: t("survey.anamnese.p_breathing.nav"), skipRules: [] },
  // { title: t("survey.anamnese.p_therapies.nav") },
  // { title: t("survey.anamnese.p_suffer.nav") },
  // { title: t("survey.anamnese.p_alertness.nav") },
  // { title: t("survey.anamnese.p_end.nav") },
  // { title: t("survey.anamnese.p_end.nav") },

  { title: " " },
  { title: " " },
  { title: " ", skipRules: [] },
  { title: " " },
  { title: " " },
  { title: " " },
  { title: " " },
];

export const anamnesisSchema = (t: (s: string) => string, page: number, paramsData: Record<string, any>): RJSFSchema => {
  const schema: RJSFSchema = {
    type: "object",
    title: t("survey.anamnese.p_start.title"),
    properties: {
      p_start: {
        description: "",
        type: "object",
        properties: {
          contact_id: {
            type: "number",
          },
          info_id: {
            type: "number",
          },
          intro: {
            type: "number",
          },
          original: {
            type: "number",
          },
          cpap: {
            type: "number",
          },
          osas_des: {
            type: "number",
          },
        },
      },
      ess_new: {
        title: "ESS Erstbefragung",
        description: "",
        type: "string",
      },
    },
  };

  if (page === 0 || page === 999) {
    (schema.properties!.p_start as any).description = t("survey.anamnese.p_start.description");
  }

  if (page === 1 || page === 999) {
    (schema.properties as any).p_contact = {
      type: "object",
      title: "",
      properties: {
        state_referred_by_doctor: {
          type: "number",
          default: 0,
        },
        fs_alert_velumount: {
          type: "object",
          title: "",
          properties: {
            alert_velumount: {
              title: t("survey.anamnese.p_contact.fs_alert_velumount.title"),
              description: "",
              type: "array",
              uniqueItems: true,
              items: {
                type: "string",
                enum: [
                  "alert_velumount_recommended",
                  "alert_velumount_intent_social_media",
                  "alert_velumount_intent_search_engines",
                  "alert_velumount_intent_tv_np",
                  // "alert_velumount_intent_internet",
                  // "alert_velumount_intent_tv_np_puls_20190513",
                  // "alert_velumount_intent_tv_np_reporter",
                  // "alert_velumount_intent_tv_np_radio",
                  // "alert_velumount_intent_tv_np_20min",
                  // "alert_velumount_intent_tv_np_bund_bz",
                  // "alert_velumount_intent_tv_np_extra_20190512",
                  "alert_velumount_by_doctor",
                  "alert_velumount_by_physio",
                  "alert_velumount_by_traditional",
                  "alert_velumount_other",
                ],
              },
            },
          },
          dependencies: {
            alert_velumount: {
              allOf: [
                {
                  if: {
                    properties: {
                      alert_velumount: {
                        type: "array",
                        contains: {
                          const: "alert_velumount_other",
                        },
                      },
                    },
                  },
                  then: {
                    properties: {
                      alert_velumount_other_input: {
                        title: t("survey.anamnese.p_contact.fs_alert_velumount.alert_velumount_other_input"),
                        description: "",
                        type: "string",
                      },
                    },
                  },
                },
              ],
            },
          },
          description: "",
        },
      },
      dependencies: {
        state_referred_by_doctor: {
          allOf: [
            {
              if: {
                properties: {
                  state_referred_by_doctor: {
                    const: 1,
                  },
                },
              },
              then: {
                properties: {
                  fs_referred_physician: {
                    type: "object",
                    title: t("survey.anamnese.p_contact.fs_referred_physician.title"),
                    properties: {
                      referred_physician: {
                        title: t("survey.anamnese.p_contact.fs_referred_physician.referred_physician.title"),
                        description: "",
                        type: "string",
                      },
                      referred_physician_place: {
                        title: t("survey.anamnese.p_contact.fs_referred_physician.referred_physician_place.title"),
                        description: "",
                        type: "string",
                      },
                      referred: {
                        title: t("survey.anamnese.p_contact.fs_referred_physician.referred.title"),
                        description: "",
                        type: "string",
                        enum: ["is_referred_recommended", "is_referred_written"],
                      },
                    },
                    description: "",
                  },
                },
              },
            },
          ],
        },
      },
      description: "",
    };
  }

  if (page === 2 || page === 999) {
    (schema.properties as any).p_breathing = {
      type: "object",
      title: "",
      properties: {
        state_osas_diagnosis: {
          type: "number",
          default: 0,
        },
        fs_osas_sleep: {
          type: "object",
          title: "",
          properties: {
            fs_osas_sleep_title: {
              title: t("survey.anamnese.p_breathing.fs_osas_sleep.title"),
            },
            osas: {
              title: t("survey.anamnese.p_breathing.fs_osas_sleep.osas.title"),
              description: "",
              type: "string",
              enum: ["osas_no", "osas_assumed", "osas_yes"],
            },
          },
          dependencies: {
            osas: {
              oneOf: [
                {
                  properties: {
                    osas: {
                      enum: ["osas_no"],
                    },
                  },
                },
                {
                  properties: {
                    osas: {
                      enum: ["osas_yes", "osas_assumed"],
                    },
                    osas_source: {
                      description: "",
                      uniqueItems: true,
                      title: t("survey.anamnese.p_breathing.fs_osas_sleep.osas_source.title"),
                      type: "array",
                      items: {
                        type: "string",
                        enum: ["osas_observed", "osas_self", "osas_diagnosis"],
                      },
                    },
                  },
                  required: ["osas_source"],
                },
              ],
            },
          },
          description: "",
        },
      },
      dependencies: {
        state_osas_diagnosis: {
          allOf: [
            {
              if: {
                properties: {
                  state_osas_diagnosis: {
                    const: 1,
                  },
                },
              },
              then: {
                properties: {
                  fs_osas_diagnosis: {
                    type: "object",
                    title: "",
                    properties: {
                      fs_osas_diagnosis_title: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.title"),
                      },
                      osas_physician: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_physician.title"),
                        description: "",
                        type: "string",
                      },
                      osas_physician_place: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_physician_place.title"),
                        description: "",
                        type: "string",
                      },
                      osas_specialization: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_specialization.title"),
                        description: "",
                        type: "string",
                        enum: ["end-doctor", "pneumology", "general_practitioner", "other"],
                      },
                      osas_ahi_year: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_ahi_year.title"),
                        description: "",
                        type: "number",
                      },
                      osas_ahi: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_ahi.title"),
                        description: "",
                        type: "number",
                      },
                      osas_sleeplab: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_sleeplab.title"),
                        description: "",
                        type: "string",
                        enum: ["easy", "medium", "serious", "unknown"],
                      },
                      osas_report: {
                        title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_report.title"),
                        description: "",
                        type: "string",
                        enum: ["no", "yes"],
                      },
                    },
                    dependencies: {
                      osas_specialization: {
                        oneOf: [
                          {
                            properties: {
                              osas_specialization: {
                                not: {
                                  const: "other",
                                },
                              },
                            },
                          },
                          {
                            properties: {
                              osas_specialization: {
                                const: "other",
                              },
                              osas_other_medical_section: {
                                type: "string",
                                title: t("survey.anamnese.p_breathing.fs_osas_diagnosis.osas_other_medical_section.title"),
                              },
                            },
                          },
                        ],
                      },
                    },
                    description: "",
                  },
                },
              },
              else: {
                properties: {
                  fs_ent_visit: {
                    type: "object",
                    title: "",
                    properties: {
                      fs_ent_visit_title: {
                        title: t("survey.anamnese.p_breathing.fs_ent_visit.title"),
                      },
                      hno_year: {
                        title: t("survey.anamnese.p_breathing.fs_ent_visit.hno_year.title"),
                        description: "",
                        type: "number",
                      },
                    },
                    description: "",
                  },
                },
              },
            },
          ],
        },
      },
      description: "",
    };
  }

  if (page === 3 || page === 999) {
    (schema.properties as any).p_therapies = {
      type: "object",
      title: "",
      properties: {
        state_applied_cpap_therapy: {
          default: 1,
          type: "number",
        },
        fs_therapies: {
          type: "object",
          title: "",
          properties: {
            fs_therapies_title: {
              title: t("survey.anamnese.p_therapies.fs_therapies.title"),
            },
            recommended_therapies: {
              title: t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.title"),
              description: t("survey.anamnese.p_therapies.fs_therapies.recommended_therapies.description"),
              uniqueItems: true,
              type: "array",
              items: {
                type: "string",
                enum: ["none", "CPAP", "Operation", "Protrusion", "Nosetape", "Spirotiger", "Velumount", "other"],
              },
            },
            applied_therapies: {
              title: t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.title"),
              description: t("survey.anamnese.p_therapies.fs_therapies.applied_therapies.description"),
              type: "array",
              uniqueItems: true,
              items: {
                type: "string",
                enum: ["none", "CPAP", "Protrusion", "Nosetape", "Spirotiger", "other"],
              },
            },
          },
          allOf: [
            {
              if: {
                properties: {
                  recommended_therapies: {
                    contains: { const: "other" },
                  },
                },
              },
              then: {
                properties: {
                  other_recom_therapies: {
                    title: t("survey.anamnese.p_therapies.fs_therapies.other_recom_therapies.title"),
                    description: "",
                    type: "string",
                  },
                },
                // required: ["other_recom_therapies"],
              },
            },
            {
              if: {
                properties: {
                  recommended_therapies: {
                    contains: { const: "Operation" },
                  },
                },
              },
              then: {
                properties: {
                  operation: {
                    title: t("survey.anamnese.p_therapies.fs_therapies.operation.title"),
                    description: "",
                    type: "string",
                    enum: ["no", "yes"],
                  },
                },
              },
            },
            {
              if: {
                required: ["operation"],
                properties: {
                  operation: { const: "yes" },
                },
              },
              then: {
                properties: {
                  operation_where: {
                    title: t("survey.anamnese.p_therapies.fs_therapies.operation_where.title"),
                    description: t("survey.anamnese.p_therapies.fs_therapies.operation_where.description"),
                    type: "array",
                    uniqueItems: true,
                    items: {
                      type: "string",
                      enum: ["tonsils", "mocous_membranes", "tooth_position", "tongue", "palate", "nose"],
                    },
                  },
                },
              },
            },
            {
              if: {
                properties: {
                  applied_therapies: {
                    contains: { const: "other" },
                  },
                },
              },
              then: {
                properties: {
                  other_therapies: {
                    title: t("survey.anamnese.p_therapies.fs_therapies.other_applied_therapies.title"),
                    description: "",
                    type: "string",
                  },
                },
                // required: ["other_therapies"],
              },
            },
          ],
          description: "",
        },
      },
      allOf: [
        {
          if: {
            properties: {
              state_applied_cpap_therapy: {
                const: 1,
              },
            },
          },
          then: {
            properties: {
              fs_cpap_using_1: {
                type: "object",
                title: "",
                properties: {
                  fs_cpap_using_1_title: {
                    title: t("survey.anamnese.p_therapies.fs_cpap_using_1.title"),
                  },
                  cpap_using_current_1: {
                    title: t("survey.anamnese.p_therapies.fs_cpap_using_1.cpap_using_current_1.title"),
                    description: "",
                    type: "string",
                    enum: [
                      "always (6-7 times per week)",
                      "often (ca. 2-5 times per week)",
                      "rarly (less than 2 times per week)",
                      "never, but i keep the cpap at home",
                      "never, i retourned the cpap",
                    ],
                  },
                },
                description: "",
              },
            },
          },
        },
      ],
      description: "",
    };
  }

  if (page === 4 || page === 999) {
    (schema.properties as any).p_suffer = {
      type: "object",
      title: "",
      properties: {
        fs_suffer: {
          type: "object",
          title: "",
          properties: {
            fs_suffer_title: {
              title: t("survey.anamnese.p_suffer.fs_suffer.title"),
            },
            assess_suffer_1: {
              title: t("survey.custom.assess_suffer.self_assess_suffer_1.title"),
              type: "object",
              rows: {
                type: "array",
                enum: ["self_assess_suffer_1"],
              },
              columns: {
                type: "array",
                enum: ["well bearable", "rather well bearable", "medium", "rather unbearable", "unbearable"],
              },
            } as any,

            suffer_person_concerned_1: {
              title: t("survey.custom.assess_suffer.suffer_person_concerned_1.title"),
              type: "object",
              rows: {
                type: "array",
                enum: ["suffer_person_concerned_1"],
              },
              columns: {
                type: "array",
                enum: ["well bearable", "rather well bearable", "medium", "rather unbearable", "unbearable"],
              },
            } as any,
          },
          description: "",
        },
        fs_symptomens: {
          type: "object",
          title: "",
          properties: {
            fs_symptomens_title: {
              title: t("survey.anamnese.p_suffer.fs_symptomens.title"),
            },
            symptoms: {
              title: t("survey.anamnese.p_suffer.fs_symptomens.symptoms.title"),
              description: t("survey.anamnese.p_suffer.fs_symptomens.symptoms.description"),
              type: "array",
              uniqueItems: true,
              items: {
                type: "string",
                enum: [
                  "none",
                  "Tagesmüdigkeit",
                  "Einschlafneigung tagsüber",
                  "Konzentrationsprobleme",
                  "Erhöhter Blutdruck",
                  "Morgendliche Kopfschmerzen",
                  "Nächtliches Schwitzen",
                  "Bruxismus (Zähneknirschen)",
                  "Reflux (saures Aufstossen)",
                ],
              },
            },
          },
          description: "",
        },
        fs_medication: {
          type: "object",
          title: "",
          properties: {
            fs_medication_title: {
              title: t("survey.anamnese.p_suffer.fs_medication.title"),
            },
            medication: {
              title: t("survey.anamnese.p_suffer.fs_medication.medication.title"),
              description: t("survey.anamnese.p_suffer.fs_medication.medication.description"),
              type: "array",
              uniqueItems: true,
              items: {
                type: "string",
                enum: ["none", "blood_thinner", "blood_lower", "psychopharmaka", "hypnotic"],
              },
            },
          },
          description: "",
        },
        fs_epilepsy: {
          type: "object",
          title: "",
          properties: {
            fs_epilepsy_title: {
              title: t("survey.anamnese.p_suffer.fs_epilepsy.title"),
            },
            epilepsy: {
              title: t("survey.anamnese.p_suffer.fs_epilepsy.epilepsy.title"),
              description: "",
              type: "string",
              enum: ["no", "yes"],
            },
          },
          dependencies: {
            epilepsy: {
              oneOf: [
                {
                  properties: {
                    epilepsy: {
                      const: "no",
                    },
                  },
                },
                {
                  properties: {
                    epilepsy: {
                      const: "yes",
                    },
                    epilepsy_last_occurance: {
                      title: t("survey.anamnese.p_suffer.fs_epilepsy.epilepsy_last_occurance.title"),
                      description: "",
                      type: "string",
                    },
                  },
                },
              ],
            },
          },
          description: "",
        },
      },
      description: "",
    };
  }

  if (page === 5 || page === 999) {
    (schema.properties as any).p_alertness = {
      type: "object",
      title: "",
      properties: {
        fs_fall_asleep_1: {
          type: "object",
          title: "",
          properties: {
            epworth_title: {
              type: "string",
              title: t("survey.custom.epworth.title"),
            },
            epworth_description: {
              type: "object",
              description: t("survey.custom.epworth.description"),
            },
            epworth: {
              properties: {
                epworth: {
                  type: "object",
                  rows: {
                    type: "array",
                    enum: [
                      // REMOVE PREFIX??
                      "epworth_Sitting and readin",
                      "epworth_Watching TV",
                      "epworth_Sitting, inactive in a public place",
                      "epworth_As a passenger in a car for an hour without break",
                      "epworth_Lying down to rest in the afternoon",
                      "epworth_Sitting an talking to someone",
                      "epworth_Sitting quietly after lunch without alcohol",
                      "epworth_In a car while stopped for a few minutes in the traffic",
                    ],
                  },
                  columns: {
                    type: "array",
                    enum: ["1", "2", "3", "4"],
                  },
                } as any,
              },
            },
          },
          description: "",
        },
        fs_relaxed_1: {
          type: "object",
          title: "",
          properties: {
            fs_relaxed_1_title: {
              title: t("survey.anamnese.p_alertness.fs_relaxed_1.title"),
            },
            relaxed_1: {
              title: t("survey.anamnese.p_alertness.fs_relaxed_1.relaxed_1.title"),
              description: "",
              type: "string",
              enum: ["almost always", "often", "sometimes", "rare", "never"],
            },
          },
          description: "",
        },
        fs_comment: {
          type: "object",
          title: "",
          properties: {
            fs_comment_title: {
              title: t("survey.anamnese.p_alertness.fs_comment.title"),
            },
            comment: {
              title: t("survey.anamnese.p_alertness.fs_comment.comment.title"),
              type: "string",
            },
          },
          description: "",
        },
      },
      description: "",
    };
  }

  if (page === 6 || page === 999) {
    (schema.properties as any).p_end = {
      type: "object",
      title: "",
      properties: {
        fs_additional_data: {
          type: "object",
          title: "",
          properties: {
            fs_additional_data_title: {
              title: t("survey.anamnese.p_end.fs_additional_data.title"),
            },
            weight: {
              title: t("survey.anamnese.p_end.fs_additional_data.weight.title"),
              description: "",
              type: "number",
            },
            size: {
              title: t("survey.anamnese.p_end.fs_additional_data.size.title"),
              description: "",
              type: "number",
            },
          },
          description: "",
        },
        goodbye: {
          description: t("survey.anamnese.p_end.goodbye"),
          type: "string",
        },
      },
      description: "",
    };
  }

  return schema;
};
